/* NORQAIN collection facets
   Handles panels, price slider, AJAX updates and chips. */

(function () {
	'use strict';

	var ROOT_ID = 'ajax-collection';
	var MOBILE_BP = 900;
	var abortCtrl = null;

	function isMobile() {
		return window.matchMedia('(max-width: ' + MOBILE_BP + 'px)').matches;
	}

	function money(cents) {
		var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CHF';
		var loc = document.documentElement.lang || 'en';
		try {
			return new Intl.NumberFormat(loc, {
				style: 'currency',
				currency: cur,
				minimumFractionDigits: 0,
				maximumFractionDigits: 0
			}).format(cents / 100);
		} catch (e) {
			return Math.round(cents / 100).toString();
		}
	}

	function parseNumber(str) {
		if (str == null) return NaN;
		var s = String(str).replace(/[^\d.,-]/g, '').trim();
		if (!s) return NaN;
		var lastComma = s.lastIndexOf(',');
		var lastDot = s.lastIndexOf('.');
		if (lastComma > lastDot) {
			s = s.replace(/\./g, '').replace(',', '.');
		} else {
			s = s.replace(/,/g, '');
		}
		var n = parseFloat(s);
		return isNaN(n) ? NaN : n;
	}

	/* ---------- Price control ---------- */

	function initPrice(root, apply) {
		var el = root.querySelector('[data-nq-price]');
		if (!el) return;

		var ceil = parseInt(el.dataset.ceil, 10) || 0;
		var lower = el.querySelector('[data-nq-price-lower]');
		var upper = el.querySelector('[data-nq-price-upper]');
		var fill = el.querySelector('[data-nq-price-fill]');
		var labelMin = el.querySelector('[data-nq-price-label-min]');
		var labelMax = el.querySelector('[data-nq-price-label-max]');
		var inMin = el.querySelector('[data-nq-price-input-min]');
		var inMax = el.querySelector('[data-nq-price-input-max]');
		var paramMin = el.querySelector('[data-nq-price-param-min]');
		var paramMax = el.querySelector('[data-nq-price-param-max]');
		var slider = el.querySelector('.nq-price__slider');

		if (!ceil || !lower || !upper) return;

		/* Real product prices, in cents. The handles land only on these,
		   so every stop changes the result set. 0 and the ceiling are
		   always included so the range can be fully opened. */

		var points = (el.dataset.points || '')
			.split(',')
			.map(function (v) { return parseInt(v, 10); })
			.filter(function (v) { return !isNaN(v) && v >= 0 && v <= ceil; });

		points.push(0);
		points.push(ceil);
		points = points.filter(function (v, i, a) { return a.indexOf(v) === i; });
		points.sort(function (a, b) { return a - b; });

		function snap(v) {
			var best = points[0];
			var bestD = Math.abs(v - best);
			for (var i = 1; i < points.length; i++) {
				var d = Math.abs(v - points[i]);
				if (d < bestD) { best = points[i]; bestD = d; }
			}
			return best;
		}

		/* Tick marks so the stops are visible */

		if (slider && points.length > 2 && points.length <= 80) {
			var ticks = document.createElement('div');
			ticks.className = 'nq-price__ticks';
			points.forEach(function (p) {
				if (p === 0 || p === ceil) return;
				var t = document.createElement('span');
				t.className = 'nq-price__tick';
				t.style.left = (p / ceil * 100) + '%';
				ticks.appendChild(t);
			});
			slider.appendChild(ticks);
		}

		lower.value = snap(parseInt(lower.value, 10) || 0);
		upper.value = snap(parseInt(upper.value, 10) || ceil);

		function paint() {
			var a = parseInt(lower.value, 10);
			var b = parseInt(upper.value, 10);
			var lo = Math.min(a, b);
			var hi = Math.max(a, b);

			fill.style.left = (lo / ceil * 100) + '%';
			fill.style.width = ((hi - lo) / ceil * 100) + '%';

			labelMin.textContent = money(lo);
			labelMax.textContent = money(hi);

			if (document.activeElement !== inMin) inMin.value = Math.round(lo / 100);
			if (document.activeElement !== inMax) inMax.value = Math.round(hi / 100);
		}

		function commit() {
			var lo = Math.min(parseInt(lower.value, 10), parseInt(upper.value, 10));
			var hi = Math.max(parseInt(lower.value, 10), parseInt(upper.value, 10));

			// Only send a bound when it is actually narrower than the full range.
			paramMin.value = lo > 0 ? (lo / 100) : '';
			paramMax.value = hi < ceil ? (hi / 100) : '';
			apply();
		}

		lower.addEventListener('input', function () {
			lower.value = snap(parseInt(lower.value, 10));
			if (parseInt(lower.value, 10) > parseInt(upper.value, 10)) {
				lower.value = upper.value;
			}
			paint();
		});

		upper.addEventListener('input', function () {
			upper.value = snap(parseInt(upper.value, 10));
			if (parseInt(upper.value, 10) < parseInt(lower.value, 10)) {
				upper.value = lower.value;
			}
			paint();
		});

		lower.addEventListener('change', commit);
		upper.addEventListener('change', commit);

		function fieldCommit(input, target, isMin) {
			var n = parseNumber(input.value);
			if (isNaN(n)) {
				target.value = isMin ? 0 : ceil;
			} else {
				var cents = Math.round(n * 100);
				cents = Math.max(0, Math.min(ceil, cents));
				target.value = snap(cents);
			}
			if (parseInt(lower.value, 10) > parseInt(upper.value, 10)) {
				if (isMin) { lower.value = upper.value; } else { upper.value = lower.value; }
			}
			paint();
			commit();
		}

		// Validate on blur and on Enter only, never on keystroke.
		inMin.addEventListener('blur', function () { fieldCommit(inMin, lower, true); });
		inMax.addEventListener('blur', function () { fieldCommit(inMax, upper, false); });

		[inMin, inMax].forEach(function (i) {
			i.addEventListener('keydown', function (e) {
				if (e.key === 'Enter') { e.preventDefault(); i.blur(); }
			});
		});

		paint();
	}

	/* ---------- AJAX ---------- */

	function buildUrl(form) {
		var data = new FormData(form);
		var params = new URLSearchParams();
		data.forEach(function (v, k) {
			if (v === '' || v == null) return;
			params.append(k, v);
		});
		var qs = params.toString();
		return window.location.pathname + (qs ? '?' + qs : '');
	}

	function render(url, opts) {
		opts = opts || {};
		var wrap = document.querySelector('.nq-facets-wrap');
		var grid = document.getElementById('collection-grid');
		if (wrap) wrap.classList.add('is-loading');
		if (grid) grid.classList.add('is-loading');

		if (abortCtrl) abortCtrl.abort();
		abortCtrl = new AbortController();

		fetch(url, { signal: abortCtrl.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } })
			.then(function (r) { return r.text(); })
			.then(function (html) {
				var doc = new DOMParser().parseFromString(html, 'text/html');
				var fresh = doc.getElementById(ROOT_ID);
				var current = document.getElementById(ROOT_ID);
				if (!fresh || !current) { window.location.assign(url); return; }

				/* Carry the sheet's open state onto the incoming markup
				   BEFORE it enters the document, so it is already open
				   when it paints and there is no close-and-reopen flash. */

				if (opts.sheetOpen) {
					var freshPanels = fresh.querySelector('[data-nq-panels]');
					if (freshPanels) {
						freshPanels.classList.add('is-open');
						freshPanels.querySelectorAll('[data-nq-panel]').forEach(function (p) {
							p.hidden = false;
						});
					}
					(opts.expanded || []).forEach(function (idx) {
						var p = fresh.querySelector('[data-nq-panel="' + idx + '"]');
						if (!p) return;
						p.classList.add('is-expanded');
						var head = p.querySelector('[data-nq-accordion]');
						if (head) head.setAttribute('aria-expanded', 'true');
					});
				}

				var scrollY = window.scrollY;
				var sheetScrollTop = 0;
				var oldScroll = current.querySelector('.nq-facets__sheet-scroll');
				if (oldScroll) sheetScrollTop = oldScroll.scrollTop;

				current.innerHTML = fresh.innerHTML;
				window.history.replaceState({ nqFacets: true }, '', url);

				init({
					openPanel: opts.openPanel,
					sheetOpen: opts.sheetOpen,
					sheetScrollTop: sheetScrollTop
				});
				window.scrollTo(0, scrollY);

				document.dispatchEvent(new CustomEvent('nq:facets:updated'));
			})
			.catch(function (err) {
				if (err && err.name === 'AbortError') return;
				window.location.assign(url);
			});
	}

	/* ---------- Init ---------- */

	function init(state) {
		state = state || {};

		var form = document.getElementById('col-facets');
		if (!form) return;

		var wrap = document.querySelector('.nq-facets-wrap');
		var panels = form.querySelector('[data-nq-panels]');
		var tabs = Array.prototype.slice.call(form.querySelectorAll('[data-nq-tab]'));
		var openPanel = null;

		if (!panels) return;

		var backdrop = document.querySelector('.nq-facets__backdrop');
		if (!backdrop) {
			backdrop = document.createElement('div');
			backdrop.className = 'nq-facets__backdrop';
			document.body.appendChild(backdrop);
		}

		function sheetIsOpen() {
			return isMobile() && panels.classList.contains('is-open');
		}

		function expandedPanels() {
			var out = [];
			form.querySelectorAll('[data-nq-panel].is-expanded').forEach(function (p) {
				out.push(p.dataset.nqPanel);
			});
			return out;
		}

		function apply(opts) {
			opts = opts || {};
			render(buildUrl(form), {
				openPanel: opts.keepPanel ? openPanel : null,
				sheetOpen: sheetIsOpen(),
				expanded: expandedPanels()
			});
		}

		/* Desktop panels: one open at a time */

		function closePanel() {
			tabs.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
			form.querySelectorAll('[data-nq-panel]').forEach(function (p) { p.hidden = true; });
			panels.classList.remove('is-open');
			openPanel = null;
		}

		function showPanel(idx) {
			if (openPanel === idx) { closePanel(); return; }
			tabs.forEach(function (t) {
				t.setAttribute('aria-expanded', t.dataset.nqTab === idx ? 'true' : 'false');
			});
			form.querySelectorAll('[data-nq-panel]').forEach(function (p) {
				p.hidden = p.dataset.nqPanel !== idx;
			});
			panels.classList.add('is-open');
			openPanel = idx;
		}

		/* Mobile sheet */

		function openSheet() {
			panels.classList.add('is-open');
			panels.querySelectorAll('[data-nq-panel]').forEach(function (p) { p.hidden = false; });
			backdrop.classList.add('is-visible');
			if (wrap) wrap.classList.add('nq-sheet-open');
			document.body.style.overflow = 'hidden';
		}

		function closeSheet() {
			panels.classList.remove('is-open');
			backdrop.classList.remove('is-visible');
			if (wrap) wrap.classList.remove('nq-sheet-open');
			document.body.style.overflow = '';
		}

		tabs.forEach(function (tab) {
			tab.addEventListener('click', function () { showPanel(tab.dataset.nqTab); });
		});

		document.addEventListener('click', function (e) {
			if (isMobile()) return;
			if (!openPanel) return;
			if (form.contains(e.target)) return;
			closePanel();
		});

		document.addEventListener('keydown', function (e) {
			if (e.key !== 'Escape') return;
			if (isMobile()) { closeSheet(); } else { closePanel(); }
		});

		form.querySelectorAll('[data-nq-sheet-open]').forEach(function (b) {
			b.addEventListener('click', openSheet);
		});

		form.querySelectorAll('[data-nq-sheet-close]').forEach(function (b) {
			b.addEventListener('click', closeSheet);
		});

		backdrop.addEventListener('click', closeSheet);

		form.querySelectorAll('[data-nq-accordion]').forEach(function (head) {
			head.addEventListener('click', function (e) {
				e.preventDefault();
				e.stopPropagation();
				var panel = head.closest('[data-nq-panel]');
				if (!panel) return;
				var expanded = panel.classList.toggle('is-expanded');
				head.setAttribute('aria-expanded', expanded ? 'true' : 'false');
			});
		});

		/* Checkboxes apply immediately, same as desktop. The sheet stays
		   open and the open category stays expanded because render()
		   carries that state onto the incoming markup. */

		form.querySelectorAll('.nq-facets__cb').forEach(function (cb) {
			cb.addEventListener('change', function () { apply({ keepPanel: true }); });
		});

		/* Sort */

		var sort = form.querySelector('[data-nq-sort]');
		if (sort) {
			sort.addEventListener('change', function () {
				var hidden = document.getElementById('sort_by');
				if (hidden) hidden.value = sort.value;
				apply();
			});
		}

		/* Chips and clear */

		document.querySelectorAll('[data-nq-remove]').forEach(function (btn) {
			btn.addEventListener('click', function () {
				render(btn.dataset.nqRemove);
			});
		});

		document.querySelectorAll('[data-nq-clear]').forEach(function (btn) {
			btn.addEventListener('click', function () {
				var keep = '';
				var hidden = document.getElementById('sort_by');
				if (hidden && hidden.value && hidden.value !== 'manual') {
					keep = '?sort_by=' + encodeURIComponent(hidden.value);
				}
				render(window.location.pathname + keep);
			});
		});

		/* Price */

		initPrice(form, function () { apply({ keepPanel: true }); });

		/* Never let the form do a native submit */

		form.addEventListener('submit', function (e) {
			e.preventDefault();
			apply();
		});

		/* The sticky bar has to stop below the fixed header rather than
		   at the viewport top, or it slides underneath it. Measure the
		   header instead of hardcoding a height, since it differs
		   between breakpoints and shrinks on scroll. */

		function setHeaderOffset() {
			var header = document.querySelector('#shopify-section-header, .gheader');
			var h = header ? Math.round(header.getBoundingClientRect().height) : 0;
			document.documentElement.style.setProperty('--nq-header-h', h + 'px');
		}

		setHeaderOffset();
		window.addEventListener('resize', setHeaderOffset);
		window.addEventListener('scroll', setHeaderOffset, { passive: true });

		/* Restore state after an AJAX re-render */

		if (state.openPanel && !isMobile()) showPanel(state.openPanel);

		if (state.sheetOpen && isMobile()) {
			openSheet();
			if (state.sheetScrollTop) {
				var sc = form.querySelector('.nq-facets__sheet-scroll');
				if (sc) sc.scrollTop = state.sheetScrollTop;
			}
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () { init(); });
	} else {
		init();
	}

	window.addEventListener('popstate', function () {
		window.location.reload();
	});
})();